const DB_NAME = 'samjin-bundle';
const DB_VERSION = 1;
const STORE_NAME = 'bundle';

let memoryCache = null;

function getEnvPrefix() {
  const base = process.env.REACT_APP_API_BASE_URL || '';
  if (base.includes('api-dev') || base.includes('-dev')) return 'erp-dev';
  if (base.includes('api-prod') || base.includes('-prod')) return 'erp-prod';
  if (process.env.NODE_ENV === 'production') return 'erp-prod';
  return 'erp-local';
}

export function getBundleStorageKey() {
  return `${getEnvPrefix()}.bundle.v1`;
}

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB is not available'));
      return;
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error || new Error('IndexedDB open failed'));
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

export function getMemoryBundleRecord() {
  return memoryCache;
}

export function setMemoryBundleRecord(record) {
  memoryCache = record;
}

export function clearMemoryBundleRecord() {
  memoryCache = null;
}

export async function readBundleRecord() {
  if (memoryCache) {
    return memoryCache;
  }
  try {
    const db = await openDb();
    const key = getBundleStorageKey();
    const record = await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(key);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
    db.close();
    if (record) {
      memoryCache = record;
    }
    return record;
  } catch (error) {
    console.warn('[bundleStorage] read failed:', error);
    return memoryCache;
  }
}

export async function writeBundleRecord(record) {
  memoryCache = record;
  try {
    const db = await openDb();
    const key = getBundleStorageKey();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.put(record, key);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
    db.close();
  } catch (error) {
    console.warn('[bundleStorage] write failed (memory-only):', error);
  }
}

export async function clearBundleRecord() {
  memoryCache = null;
  try {
    const db = await openDb();
    const key = getBundleStorageKey();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.delete(key);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
    db.close();
  } catch (error) {
    console.warn('[bundleStorage] clear failed:', error);
  }
}
